import React from 'react'

import { Box } from '@chakra-ui/react'

import type { ColorScheme } from '../../types'

export type KebabHorizontalIconProps = {
  size?: number
  color?: string
  colorScheme?: ColorScheme
  className?: string
}

export const KebabHorizontalIcon = ({
  size = 20,
  colorScheme,
  color,
  className,
}: KebabHorizontalIconProps) => (
  <Box
    alignItems='center'
    color={
      color ??
      (colorScheme === 'light' ? 'light.icon.secondary' : 'icon.secondary')
    }
    display='flex'
  >
    <svg
      aria-label='More options'
      className={className}
      fill='currentColor'
      height={size}
      role='img'
      viewBox='0 0 20 20'
      width={size}
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='2' cy='10' r='2' />
      <circle cx='10' cy='10' r='2' />
      <circle cx='18' cy='10' r='2' />
    </svg>
  </Box>
)
